import { useState } from "react"
import { columnDataType } from "utils/types"
import { displayType } from "../model/types";
import { validateDate, validateLink, validateNumber } from "./validate-functions"
import { getColumnType } from "utils/helpers";
import { showToast } from "utils/helpers";

export const useRowValue = ({
	cell,
	row,
}) => {

	const columnId = cell.column.id;
	const columnMetaData = cell.column.columnDef.meta;
	const type = getColumnType(columnMetaData?.type);
	const cellInitData = row.original[columnId];

	const [value, setValue] = useState(cellInitData)
	const [error, setError] = useState('')

	const validateFunctionsByType = {
		[columnDataType.boolean]: () => '',
		[columnDataType.date]: validateDate,
		[columnDataType.link]: validateLink,
		[columnDataType.number]: validateNumber,
		[columnDataType.text]: () => '',
		[columnDataType.default]: () => '',
	};

	const validate = validateFunctionsByType[type]

	const handleValidate = () => {
		const error = validate(value);
		if (!!error) {
			showToast(false, error);
		};
		setError(error);
		return error
	}

	return {
		value,
		error,
		setValue,
		validate: handleValidate,
	}
}